/**
 * ThemePalette を CSS 変数として `:root` に書き込み、Tailwind の cyan-* / teal-* 等の
 * クラスを実行時にブランドカラーへ差し替える。
 *
 * Tailwind v4 の `bg-cyan-500` 等は内部的に `var(--color-cyan-500)` を参照するため、
 * :root で同名の CSS 変数を上書きすれば既存クラスが追加改修なしで色を切り替えられる。
 */
import type { ColorScale, ThemePalette } from "./types";

const CYAN_VAR_PREFIX = "--color-cyan-";
const TEAL_VAR_PREFIX = "--color-teal-";

const SHADES = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900] as const;

const setScaleVars = (
  el: HTMLElement,
  prefix: string,
  scale: ColorScale,
): void => {
  for (const shade of SHADES) {
    el.style.setProperty(`${prefix}${shade}`, scale[shade]);
  }
};

export const applyTheme = (palette: ThemePalette): void => {
  if (typeof document === "undefined") return;
  const root = document.documentElement;

  setScaleVars(root, CYAN_VAR_PREFIX, palette.cyan);
  setScaleVars(root, TEAL_VAR_PREFIX, palette.teal);

  root.style.setProperty("--color-sina-from", palette.gradient.from);
  root.style.setProperty("--color-sina-to", palette.gradient.to);

  root.style.setProperty("--color-ink", palette.ink.base);
  root.style.setProperty("--color-ink-soft", palette.ink.soft);
  root.style.setProperty("--color-ink-mute", palette.ink.mute);

  root.style.setProperty("--color-app", palette.app.bg);
  root.style.setProperty("--color-card", palette.app.card);

  // CSS / E2E から「現在どのアプリのテーマか」を参照できるようにする
  root.dataset.appId = palette.appId;
};
